import { deviceTableHeadMap } from './device/mapper';
import { projectTableHeadMap } from './project/mapper';
import { userTableHeadMap } from './user/mapper';
import { shipmentTableHeadMap } from './shipment/mapper';
import { tableNameType } from '#type';

export const tableHeadMap = {
  [tableNameType.DEVICE_TABLE]: deviceTableHeadMap,
  [tableNameType.PROJECT_TABLE]: projectTableHeadMap,
  [tableNameType.USER_TABLE]: userTableHeadMap,
  [tableNameType.SHIPMENT_TABLE]: shipmentTableHeadMap
};
